module.exports = {


  footerText: '®2022 Todos los derechos reservados. Desarrollado por Intersistemas, S.A. de C.V.',
  version: 'v1.9.6'

};
